import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";

type HandleArgs = {
  realEstateId: string | number;
};

const useActivationRequest = () => {
  const { guardReadOnlyAction } = useReadOnlyModeGuard();
  const isLoading = false;

  const handleSentActivationRequest = async ({ realEstateId }: HandleArgs) => {
    guardReadOnlyAction("solicitar reactivación", "use-activation-request");
  };

  return { handleSentActivationRequest, isLoading };
};

export default useActivationRequest;
